// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop.in {
  opacity: 0.1;
}

.modal-content {
  box-shadow: 0 10px 20px -10px hsl(0, 0%, 80%);
  -webkit-box-shadow: 0 10px 20px -10px hsl(0, 0%, 80%);
  border: 1px solid hsl(0, 0%, 90%);
  border-radius: 8px;
}

.modal-header {
  padding: 16px 24px 0 24px;
  border-bottom: none;
}

.modal-body {
  padding: 16px 24px;
}

.modal-footer {
  padding: 0 24px 16px 24px;
  border: none;
}

.modal-content-small {
  width: 380px;
}
`, "",{"version":3,"sources":["webpack://./css/modal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,qDAAqD;EACrD,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".modal-backdrop.in {\n  opacity: 0.1;\n}\n\n.modal-content {\n  box-shadow: 0 10px 20px -10px hsl(0, 0%, 80%);\n  -webkit-box-shadow: 0 10px 20px -10px hsl(0, 0%, 80%);\n  border: 1px solid hsl(0, 0%, 90%);\n  border-radius: 8px;\n}\n\n.modal-header {\n  padding: 16px 24px 0 24px;\n  border-bottom: none;\n}\n\n.modal-body {\n  padding: 16px 24px;\n}\n\n.modal-footer {\n  padding: 0 24px 16px 24px;\n  border: none;\n}\n\n.modal-content-small {\n  width: 380px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
